import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {Documents} from '../upload-file/documents';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {FileUploadControl, FileUploadValidators} from '@iplab/ngx-file-upload';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {document} from 'ngx-bootstrap/utils';
import {ApiService} from '../api.service';
import {ToastrService} from 'ngx-toastr';
import {NgxSpinnerService} from 'ngx-spinner';
import {AngularEditorConfig} from '@kolkov/angular-editor';
import {regex} from '../../common/regex';
import {isLineBreak} from 'codelyzer/angular/sourceMappingVisitor';
import {SharedService} from '../shared-service.service';

@Component({
  selector: 'app-upload-file-incident',
  templateUrl: './upload-file-incident.component.html',
  styleUrls: ['./upload-file-incident.component.css']
})
export class UploadFileIncidentComponent implements OnInit {
  modalRef: BsModalRef;
  private _configurationId: number;
  private _uploadedFiles: Array<Documents> = [];
  private _DISABLE: boolean;
  private _incidentId: number;
  @Output() filesUpoladedEvent = new EventEmitter<Documents[]>();
  @Output() filesUpoladedEvent2 = new EventEmitter<Documents[]>();
  typeDocumentList: any = [];
  typeDocumentAdditionalList: any = [];
  documentsLoads: any = [];
  configDocumentation: any = [];
  filesUploaded: [];
  fileUpload: File;
  form: FormGroup;
  form2: FormGroup;
  form3: FormGroup;
  formMdl: FormGroup;
  myFormUploadAdditional: FormGroup;
  order: number;
  order2: number;
  base64File = ' ';
  alreadyUpload: boolean;
  orderSelected: number;
  orderSelected2: number;
  nameDocumentAdditional: string;
  documentUpload: any = {};
  dataIncident: any = [];
  private uploadedFiles2: Array<Documents> = [];
  public fileUploadControl = new FileUploadControl({listVisible: false, discardInvalid: true, accept: ['.pdf', '.jpeg', '.png', '.jpg', '.xml']},
    [FileUploadValidators.accept(['.pdf', '.jpeg', '.png', '.jpg', '.xml']), FileUploadValidators.fileSize(25428800)]);
  public fileUploadControl2 = new FileUploadControl({listVisible: false, discardInvalid: true, accept: ['.pdf', '.jpeg', '.png', '.jpg', '.xml']},
    [FileUploadValidators.accept(['.pdf', '.jpeg', '.png', '.jpg', '.xml']), FileUploadValidators.fileSize(25428800)]);
  public fileUploadControl3 = new FileUploadControl({listVisible: false, discardInvalid: true, accept: ['.pdf', '.jpeg', '.png', '.jpg', '.xml']},
    [FileUploadValidators.accept(['.pdf', '.jpeg', '.png', '.jpg', '.xml']), FileUploadValidators.fileSize(25428800)]);

  public fileUploadControlMdl = new FileUploadControl({listVisible: false, discardInvalid: true, accept: ['.pdf', '.jpeg', '.png', '.jpg', '.xml']},
    [FileUploadValidators.accept(['.pdf', '.jpeg', '.png', '.jpg', '.xml']), FileUploadValidators.fileSize(25428800)]);
  date: any;
  bsStartDate: Partial<BsDatepickerConfig>;
  isComprobanteDomicilio: boolean;
  documentId: number;
  documentValid: number;
  documentName: string;
  reasonRefusal: string;
  myFormDecline: FormGroup;
  myFormSendEmail: FormGroup;
  myFormUpload: FormGroup;
  dataSendEmail: any = {};
  isCompletedDocumentation: boolean;
  isCompletedDocumentationAdditional: boolean;
  folioInsurance: string;
  // Construimos la vista con los forms necesarios y la lista  de los documentos
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertImage',
        'insertVideo',
        'link',
        'unlink',
      ]
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ]
  };
  document: any = {};
  multiple: true;
  typeDocumentUpload: number;
  constructor(private api: ApiService,
              private toastr: ToastrService,
              private spinner: NgxSpinnerService,
              private modalService: BsModalService,
              private shared: SharedService,
              private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      orders: new FormArray([])
    });
    this.form2 = this.formBuilder.group({
      orders2: new FormArray([]),
      files2: new FormControl(),
      dateComprobanteDomicilio2: new FormControl(),
      documentName: ['', [Validators.required, Validators.maxLength(100)]]
    });
    this.myFormDecline = this.formBuilder.group({
      reasonRefusal: ['', [Validators.required, Validators.maxLength(1000)]]
    });
    this.myFormSendEmail =  this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(regex.correoElectronicolarge), Validators.maxLength(150)]],
      message : ['', [Validators.required]]
    });
    this.form3 = this.formBuilder.group({
      files3: new FormControl()
    });

    this.formMdl = this.formBuilder.group({
      filesMdl: new FormControl()
    });

    this.myFormUpload = this.formBuilder.group({
      files: new FormControl(),
      dateComprobanteDomicilio: new FormControl()
    });
    this.myFormUploadAdditional = this.formBuilder.group({
      files2: new FormControl()
    });
  }

  get ordersFormArray() {
    return this.form.controls.orders as FormArray;
  }
  get ordersFormArray2() {
    return this.form2.controls.orders2 as FormArray;
  }

  ngOnInit() {
    // El compoente de arhivos iniciará disabled always
    this.fileUploadControl.disable(true);
    this.fileUploadControl2.disable(true);
    this.alreadyUpload = true;
    this.isComprobanteDomicilio = false;
    this.isCompletedDocumentation = false;
    // inicializan valores para documentos
    this.configDocumentation = {
      configurationDocumentationId: this._configurationId,
      name: '',
      proccessId: 0,
      subproccessId: 0,
      process: '',
      subprocess: '',
      status: 0,
      createdAt: '',
      updated: '',
      number: 0,
      catTypeDocumentId: null,
      required: false,
      total: 0,
      statusName: ''
    };
    // Obtenemos los arhivos de la configuración
    this.invokeServiceGetDocuments(this.configDocumentation);
    this.invokeServiceGetIncidentDetail(this._incidentId);
  }

  invokeServiceGetDocuments(configDocumentation: any) {
    this.spinner.show('sp');
    const data = configDocumentation;
    this.api.getDocuments(data).then((data: any) => {
      if (data != null) {
        this.typeDocumentList = data;
        // Se construyen los checboxes
        this.addCheckboxes();
        this.invokeServiceGetDocumentsLoad();
        this.invokeServiceGetDocumentsAdditional();
        this.spinner.hide('sp');
      }
      this.spinner.hide('sp');
    }, error => {
      this.spinner.hide('sp');
      if (error.status === 409) {
        this.toastr.error('Hubo un error al procesar la información de los documentos.', 'Notificación');
      } else if (error.status === 204) {
        this.toastr.warning('No se encontró información de los documentos.', 'Notificación');
      }
    });
  }
  invokeServiceGetDocumentsAdditional() {
    this.spinner.show('sp');
    this.api.getDocumentsAdditionalIncident(this.incidentId).then((data: any) => {
      if (data != null) {
        this.typeDocumentAdditionalList = data;
        this.isCompletedDocumentationAdditional = true;
        this.typeDocumentAdditionalList.forEach(typeDocument => {
          typeDocument.incidentDocumentationList.forEach(typeDocument2 => {
            if (typeDocument2.valid === 0 || typeDocument2 === 2) {
              this.isCompletedDocumentationAdditional = false;
            }
          });
        });
        this.uploadedFiles2 = [];
        this.typeDocumentAdditionalList.map((DOCCMODEL) => {
          DOCCMODEL.incidentDocumentationList.forEach(DOCC => {
            const documents = new Documents();
            documents.base64 = DOCC.base;
            documents.number = 0;
            documents.name = DOCC.documentName;
            documents.idDocument = DOCC.incidentDocumentId;
            this.uploadedFiles2.push(documents);
          });
        });
        // console.log(this.uploadedFiles2);
        this.addCheckboxes2();
      } else {
        this.isCompletedDocumentationAdditional = true;
        this.typeDocumentAdditionalList = [];
        this.ordersFormArray2.clear();
        this.deleteFileIfExist();
        this.documentId = 0;
      }
      this.spinner.hide('sp');
    }, error => {
      this.spinner.hide('sp');
      if (error.status === 409) {
        this.toastr.error('Hubo un error al procesar la información de los documentos.', 'Notificación');
      } else if (error.status === 204) {
        this.toastr.warning('No se encontró información de los documentos.', 'Notificación');
      }
    });
  }

  private addCheckboxes() {
    this.spinner.show('sp');
    this.typeDocumentList.forEach(typeDocument => {
      // Validamos si existe en el listado para ponerlas como marcada
      if ((this._uploadedFiles.findIndex(document => document.number === typeDocument.number)) >= 0) {
        this.ordersFormArray.push(new FormControl({value: true, disabled: this._DISABLE}));
      } else {
        this.ordersFormArray.push(new FormControl({value: false, disabled: this._DISABLE}));
      }
    });
    this.spinner.hide('sp');
  }
  private addCheckboxes2() {
    this.ordersFormArray2.clear();
    this.typeDocumentAdditionalList.forEach(typeDocument => {
      // Validamos si existe en el listado para ponerlas como marcada
      // console.log(typeDocument.incidentDocumentationList.length);
      if ( typeDocument.incidentDocumentationList.length > 0 ) {
        this.ordersFormArray2.push(new FormControl({value: true, disabled: this._DISABLE}));
      } else {
        this.ordersFormArray2.push(new FormControl({value: false, disabled: this._DISABLE}));
      }
    });
  }

  // Convertimos la imágen o PDF a base64
  getBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.toString());
      reader.onerror = error => reject(error);
    });
  }

  onLoadDocument() {
    if (this.fileUploadControl.invalid) {
      this.fileUploadControl.getError().map(ERROR => {
        if (ERROR.fileSize !== undefined) {
          this.toastr.warning('Archivo inválido. El tamaño del archivo debe ser menor a 50 MB', 'Notificación');
        } else if (ERROR.fileTypes !== undefined) {
          this.toastr.warning('Archivo inválido. Formato no válido, solo PDF, JPEG, JPG y PNG', 'Notificación');
        }
      });
    } else {
      this.deleteFileIfExist();

      const documents = new Documents();

      this.getBase64(this.fileUploadControl.value[0]).then(
        res => {
          documents.File = this.fileUploadControl.value[0];
          documents.number = this.order;
          documents.base64 = res.split(',')[1];
          documents.fechaComprobanteDomicilio = this.date;
          documents.name = this.fileUploadControl.value[0].name;
          documents.idDocument = this.order2;
          this.base64File =  documents.base64;
          this._uploadedFiles.push(documents);
          this.filesUpoladedEvent.emit(this._uploadedFiles);
          this.modalRef.hide();
          // mandar a guardar documento
          this.invokeServiceSaveDocumentIncident(documents);
        }
      );
      this.alreadyUpload = true;
    }
  }

  onLoadDocument2() {
    if (this.fileUploadControl2.invalid) {
      this.fileUploadControl2.getError().map(ERROR => {
        if (ERROR.fileSize !== undefined) {
          this.toastr.warning('Archivo inválido. El tamaño del archivo debe ser menor a 25 MB', 'Notificación');
        } else if (ERROR.fileTypes !== undefined) {
          this.toastr.warning('Archivo inválido. Formato no válido, solo PDF, JPEG, JPG y PNG', 'Notificación');
        }
      });
    } else {
      this.deleteFileIfExist();

      const documents = new Documents();

      this.getBase64(this.fileUploadControl2.value[0]).then(
        res => {
          documents.File = this.fileUploadControl2.value[0];
          documents.number = this.order;
          documents.base64 = res.split(',')[1];
          documents.fechaComprobanteDomicilio = this.date;
          documents.name = this.fileUploadControl2.value[0].name;
          documents.idDocument = this.order2;
          this.base64File =  documents.base64;
          this.uploadedFiles2.push(documents);
          this.filesUpoladedEvent2.emit(this.uploadedFiles2);
          // console.log(documents);
          // mandar a guardar documento
          this.invokeServiceUpdateDocumentAdditionalIncident(documents, 0);
          this.modalRef.hide();
        }
      );
      this.alreadyUpload = true;
    }
  }
  invokeServiceSaveDocumentIncident(doc) {
    this.spinner.show('sp');
    const documentIncident = {
      incidentDocumentId: doc.idDocument,
      name: doc.name,
      path: doc.base64,
      createdDate: doc.fechaComprobanteDomicilio,
      updateDate: '',
      incidentId: this._incidentId,
      valid: 0,
      reasonRefusal: '',
      catTypeDocumentId: Number(doc.number),
      base: '',
      typeDocument: '',
      documentName: ''
    };
    this.api.saveDocumentIncident(documentIncident)
      .then(
        (response: any) => {
          this.invokeServiceGetDocumentsLoad();
          this.toastr.success('EL DOCUMENTO SE AGREGO CORRECTAMENTE', 'Notificación');
          this.spinner.hide('sp');
        }, error => {
          this.toastr.error('Ocurrió un problema al procesar su petición.', 'Notificación');
          this.spinner.hide('sp');
        }
      );
  }
  invokeServiceUpdateDocumentAdditionalIncident(doc, validate) {
    this.spinner.show('sp');
    const documentIncident = {
      incidentDocumentId: doc.idDocument,
      name: doc.name,
      path: doc.base64,
      createdDate: doc.fechaComprobanteDomicilio,
      updateDate: '',
      incidentId: this._incidentId,
      valid: validate,
      reasonRefusal: '',
      catTypeDocumentId: Number(doc.number),
      base: '',
      typeDocument: '',
      documentName: ''
    };
    this.api.updateDocumentAdditionalIncident(documentIncident)
      .then(
        (response: any) => {
          this.invokeServiceGetDocumentsAdditional();
          this.toastr.success('EL DOCUMENTO SE AGREGO CORRECTAMENTE', 'Notificación');
          this.spinner.hide('sp');
        }, error => {
          this.toastr.error('Ocurrió un problema al procesar su petición.', 'Notificación');
          this.spinner.hide('sp');
        }
      );
  }
  invokeServiceUpgradeDocumentAdditionalIncident(doc, validate) {
    this.spinner.show('sp');
    const documentIncident = {
      incidentDocumentId: doc.idDocument,
      name: doc.name,
      path: doc.base64,
      createdDate: doc.fechaComprobanteDomicilio,
      updateDate: '',
      incidentId: this._incidentId,
      valid: validate,
      reasonRefusal: '',
      catTypeDocumentId: Number(doc.number),
      base: '',
      typeDocument: '',
      documentName: ''
    };
    this.api.upgradeDocumentAdditionalIncident(documentIncident)
      .then(
        (response: any) => {
          this.invokeServiceGetDocumentsAdditional();
          this.toastr.success('EL DOCUMENTO SE AGREGO CORRECTAMENTE', 'Notificación');
          this.spinner.hide('sp');
        }, error => {
          this.toastr.error('Ocurrió un problema al procesar su petición.', 'Notificación');
          this.spinner.hide('sp');
        }
      );
  }
  saveDocumentAdditional() {
    // console.log(this.nameDocumentAdditional);
    if (this.nameDocumentAdditional === undefined || this.nameDocumentAdditional === '') {
      this.toastr.warning('DEBE DE INGRESAR EL NOMBRE DEL DOCUMENTO', 'NOTIFICACIÓN');
      return;
    }
    const documentAdditional = {
      incidentDocumentId : 0,
      name : '',
      path: '',
      createdDate: '',
      updateDate: '',
      incidentId: this._incidentId,
      valid: 0,
      reasonRefusal: '',
      catTypeDocumentId: 0,
      base: '',
      typeDocument: '',
      documentName : this.nameDocumentAdditional
    };
    this.api.saveDocumentAdditionalIncident(documentAdditional)
      .then(
        (response: any) => {
          this.modalRef.hide();
          this.invokeServiceGetDocumentsAdditional();
          this.toastr.success('EL DOCUMENTO SE AGREGO CORRECTAMENTE', 'Notificación');
          this.spinner.hide('sp');
          this.invokeServiceSendMessageCore(response);
        }, error => {
          this.toastr.error('Ocurrió un problema al procesar su petición.', 'Notificación');
          this.spinner.hide('sp');
        }
      );
  }

  invokeServiceSendMessageCore(ammia) {
    this.api.sendMessageFromCoreIncident(ammia).then((data: any) => {
      if (data == null) {
        console.log(data);
      }
    }, error => {
    });
  }

  saveDocumentAdditionalNoNotifications() {
    if (this.nameDocumentAdditional === undefined || this.nameDocumentAdditional === '') {
      this.toastr.warning('DEBE DE INGRESAR EL NOMBRE DEL DOCUMENTO', 'NOTIFICACIÓN');
      return;
    }
    const documentAdditional = {
      incidentDocumentId : 0,
      name : '',
      path: '',
      createdDate: '',
      updateDate: '',
      incidentId: this._incidentId,
      valid: 0,
      reasonRefusal: '',
      catTypeDocumentId: 0,
      base: '',
      typeDocument: '',
      documentName : this.nameDocumentAdditional
    };
    this.api.saveDocumentAdditionalIncidentNoNotifications(documentAdditional)
      .then(
        (response: any) => {
          this.invokeServiceGetDocumentsAdditional();
          this.toastr.success('EL DOCUMENTO SE AGREGO CORRECTAMENTE', 'Notificación');
          this.spinner.hide('sp');
        }, error => {
          this.toastr.error('Ocurrió un problema al procesar su petición.', 'Notificación');
          this.spinner.hide('sp');
        }
      );
  }

  deleteFileIfExist() {
    const index = this._uploadedFiles.findIndex(x => Number(x.number) === Number(this.order));
    if (index >= 0) {
      this._uploadedFiles.splice(index, 1);
    }
  }

  activateFileUpload(event, template: TemplateRef<any>) {
    this.typeDocumentUpload = 1;
    this.order2 = 0;
    this.order = event.target.value;
    this.fileUploadControl.clear();
    this.date = null;
    this.fileUploadControl.disable(true);

    // tslint:disable-next-line:triple-equals
    const file = this.typeDocumentList.filter(typeFile => typeFile.number == this.order);
    this.documentUpload = file[0];
    // console.log(this.documentUpload);
    if (event.target.checked) { // Verificar mismo checkbox, entonces, aún no han cargado file
      if (this.alreadyUpload || (this.order === this.orderSelected)) { // si ya existe un archivo
        // validar si el tipo multiple es false y ya se cargo un archivo notificar e impedir que se abra modal
        let fileExists = false;
        this.documentsLoads.forEach(typeDocument => {
          if (typeDocument.catTypeDocumentId === Number(this.order) && !this.documentUpload.multiple) {
            this.toastr.info('Ya se ha agregado el documento requerido.', 'Notificación');
            fileExists = true;
            return;
          }
        });
        if (fileExists) {
          return;
        }
        if (file[0].nameFile.includes('COMPROBANTE DE DOMICILIO')) {// Si es de un comprobante de domicilio, activar el datapicke
          this.isComprobanteDomicilio = true;
        } else {
          this.isComprobanteDomicilio = false;

          this.fileUploadControl.disable(false);
        }
        this.alreadyUpload = false;
        // invoke modal
        this.openMdlUpdateFile(template);
      } else { // Si no existe el archivo, no permitirle que seleccione otro
        this.toastr.warning('Necesitas cargar un archivo para activar la siguiente opción.', 'Notificación');
        const input = document.getElementById(event.target.id) as HTMLInputElement;
        input.checked = false;
      }
    } else {
      this.fileUploadControl.disable(true);
      this.isComprobanteDomicilio = false;
      this.alreadyUpload = true;
      this.deleteFileIfExist();
      this.filesUpoladedEvent.emit(this._uploadedFiles);
    }

    this.base64File = ' ';
    this.orderSelected = this.order;
  }

  activateFileUpload2(event, template: TemplateRef<any>) {
    // console.log(event);
    this.typeDocumentUpload = 2;
    this.order = 0;
    this.order2 = event.target.value;
    this.fileUploadControl2.clear();
    this.date = null;
    this.fileUploadControl2.disable(true);

    // tslint:disable-next-line:triple-equals
    const file = this.typeDocumentAdditionalList.filter(typeFile => typeFile.number == this.order2);

    if (event.target.checked) { // Verificar mismo checkbox, entonces, aún no han cargado file
      if (this.alreadyUpload || (this.order2 === this.orderSelected2)) { // si ya existe un archivo
          this.isComprobanteDomicilio = false;
          this.fileUploadControl2.disable(false);
          this.alreadyUpload = false;
          // invoke modal
          this.openMdlUpdateFile(template);
      } else { // Si no existe el archivo, no permitirle que seleccione otro
        this.toastr.warning('Necesitas cargar un archivo para activar la siguiente opción.', 'Notificación');
        const input = document.getElementById(event.target.id) as HTMLInputElement;
        input.checked = false;
      }
    } else {
      this.fileUploadControl2.disable(true);
      this.isComprobanteDomicilio = false;
      this.alreadyUpload = true;
      this.deleteFileIfExist();
      this.filesUpoladedEvent2.emit(this.uploadedFiles2);
    }
    this.base64File = ' ';
    this.orderSelected2 = this.order2;
  }

  seeFile(doc) {
    this.document = doc;
    this.documentId = doc.incidentDocumentId;
    // tslint:disable-next-line:variable-name
    const name_split = doc.name.split('.');
    const extension = name_split.pop();
    if (extension === 'xml') {
      // tslint:disable-next-line:max-line-length
      this.base64File = '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';
    } else {
      this.invokeServiceGetDocumentById(doc.incidentDocumentId);
   }
    this.documentValid = doc.valid;
    this.documentName = doc.name;
  }

  invokeServiceGetDocumentById(id: number) {
    this.spinner.show('sp');
    this.api.getDocumentById(id).then((data: any) => {
      if (data != null) {
        const respData = data;
        this.base64File = respData.base;
        this.spinner.hide('sp');
      }
    }, error => {
      if (error.status === 409) {
        this.toastr.error('Hubo un error al procesar la información de los documentos.', 'Notificación');
      } else if (error.status === 204) {
        this.toastr.warning('No se encontró información de los documentos.', 'Notificación');
      }
    });
  }
  invokeServiceGetDocumentsLoad() {
    this.spinner.show('sp');
    this.api.getDocumentsIncident(this._incidentId).then((result: any) => {
      if (result != null) {
        this.documentsLoads = result;
        this.isCompletedDocumentation = true;
        this.documentsLoads.forEach(typeDocument => {
          if (typeDocument.valid === 0 || typeDocument.valid === 2) {
            this.isCompletedDocumentation = false;
          }
        });
        this.spinner.hide('sp');
      }
    }, error => {
      this.spinner.hide('sp');
      if (error.status === 409) {
        this.toastr.error('Hubo un error al procesar la información de los documentos.', 'Notificación');
      } else if (error.status === 204) {
        this.toastr.warning('No se encontró información de los documentos.', 'Notificación');
      }
    });
  }

  onChangeDataPicker(event) {
    if (event != null) {
      this.fileUploadControl.disable(false);
    } else {
      this.fileUploadControl.disable(true);
    }
  }

  get configurationId(): number {
    return this._configurationId;
  }
  get incidentId(): number {
    return this._incidentId;
  }
  @Input()
  set configurationId(value: number) {
    this._configurationId = value;
  }
  // tslint:disable-next-line:adjacent-overload-signatures
  @Input()
  set incidentId(value: number) {
    this._incidentId = value;
  }
  get uploadedFiles(): Array<Documents> {
    return this._uploadedFiles;
  }
  @Input()
  set uploadedFiles(value: Array<Documents>) {
    if (value.length === 0 && this.ordersFormArray.controls.length !== 0) {
      this.ordersFormArray.controls.forEach((_ELEMENT, i) => {
        _ELEMENT.patchValue(false);
        this.base64File = ' ';
        // this.form.controls.files.setValue(null);
        this.fileUploadControl.disable(true);
        this.fileUploadControl.clear();
        this.form.controls.dateComprobanteDomicilio.setValue(null);
        this.isComprobanteDomicilio = false;

      });
    } else if ( value.length !== 0 && this.ordersFormArray.controls.length !== 0) {
      value.map(_DOCUMENT => {
        const input = document.getElementById(((_DOCUMENT.number).toString())) as HTMLInputElement;
        if ( input !== null && input !== undefined) {
          input.checked = true;
        }
      });
    }
    this._uploadedFiles = value;
  }

  @Input()
  set DISABLE(value: boolean) {
    this._DISABLE = value;
    this.ordersFormArray.controls.forEach((_ELEMENT, i) => {
      if (value) {
        _ELEMENT.disable();
      } else {
        _ELEMENT.enable();
      }
    });
  }

  confirmDelete() {
    this.api.deleteDocument(this.documentId).subscribe( response => {
      this.modalRef.hide();
      this.toastr.success('OPERACIÓN REALIZADA CON ÉXITO', 'NOTIFICACIÓN');
      this.invokeServiceGetDocumentsAdditional();
    }, error => {
      this.toastr.error('Ha sucedido un error con el servidor, contacte al administrador.', 'Notificación');
    });
  }
  closeModal() {
    this.documentId = 0;
    this.modalRef.hide();
  }
  openModalDeleteRegister(template: TemplateRef<any>, doc) {
    this.documentId = doc.incidentDocumentId;
    this.modalRef = this.modalService.show(template, {class: 'modal-sm', keyboard: false});
  }
  invokeServiceUpdateDocumentsByAuthorization(authorizationDocument) {
    this.spinner.show('sp');
    this.api.updateDocumentsByAuthorization(authorizationDocument)
      .then(
        (response: any) => {
          this.toastr.success('LA OPERACIÓN SE REALIZO CON EXITO', 'NOTIFICACIÓN');
          this.invokeServiceGetDocumentsAdditional();
          this.invokeServiceGetDocumentsLoad();
          if (authorizationDocument.valid === 2) {
            this.modalRef.hide();
            this.invokeServiceSendMessageCore(response);
          }
          this.documentId = 0;
          this.spinner.hide('sp');
          this.invokeServiceGetIncidentDetail(this._incidentId);
        }, error => {
          this.toastr.error('Ocurrió un problema al procesar su petición.', 'Notificación');
          this.spinner.hide('sp');
        }
      );
  }
  authorizeDocument() {
    const obj = {
      incidentDocumentId: this.documentId,
      valid: 1,
      reasonRefusal: '',
      incidentId: this._incidentId,
    };
    this.invokeServiceUpdateDocumentsByAuthorization(obj);
  }

  declineDocument(template: TemplateRef<any>) {
    this.reasonRefusal = '';
    this.modalRef = this.modalService.show(template, {class: 'modal-lg', keyboard: false});
  }
  declineDoc() {
    const obj = {
      incidentDocumentId: this.documentId,
      valid: 2,
      reasonRefusal: this.reasonRefusal,
      incidentId: this._incidentId,
    };
    this.invokeServiceUpdateDocumentsByAuthorization(obj);
  }

  sendEmailMdl(template: TemplateRef<any>) {
    this.api.getTextBySendEmailInsurance(this._incidentId).then((result: any) => {
      if (result != null) {
        this.dataSendEmail.message = result.text;
        this.dataSendEmail.email = '';
        this.dataSendEmail.incidentId = this._incidentId;
      }
    }, error => {
      if (error.status === 409) {
        this.toastr.error('Hubo un error al procesat petición', 'Notificación');
      } else if (error.status === 204) {
        this.toastr.warning('No se encontró información.', 'Notificación');
      }
    });
    this.modalRef = this.modalService.show(template, {class: 'modal-lg', keyboard: false});
  }
  invokeServiceSendEmail() {
    this.spinner.show('sp');
    this.api.sendEmailDocumentation(this.dataSendEmail)
      .then(
        (response: any) => {
          this.modalRef.hide();
          this.toastr.success('LA OPERACIÓN SE REALIZO CON EXITO', 'NOTIFICACIÓN');
          this.spinner.hide('sp');
          this.invokeServiceGetIncidentDetail(this._incidentId);
        }, error => {
          this.toastr.error('Ocurrió un problema al procesar su petición.', 'Notificación');
          this.spinner.hide('sp');
        }
      );
  }
  invokeServiceDownloadZip() {
    this.api.getDownloadZipDocumentation(this._incidentId)
      .subscribe(
        (response: any) => {
          if (response == null) {
            this.toastr.info('No existen archivos para descargar');
            return;
          } else {
            const dataType = response.type;
            const binaryData = [];
            binaryData.push(response);
            const downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
            downloadLink.setAttribute('download', this.dataIncident.insured + '.zip');
            document.body.appendChild(downloadLink);
            downloadLink.click();
            downloadLink.remove();
            this.invokeServiceGetIncidentDetail(this._incidentId);
          }
        }, error => {
          // console.error(error);
        }
      );
  }

  openMdlUpdateFile(template: TemplateRef<any>) {
    this.fileUploadControl3.clear();
    this.fileUploadControl2.clear();
    this.modalRef = this.modalService.show(template, {class: 'modal-lg', keyboard: false});
  }

  onLoadDocument3() {
    if (this.fileUploadControl3.invalid) {
      this.fileUploadControl3.getError().map(ERROR => {
        if (ERROR.fileSize !== undefined) {
          this.toastr.warning('Archivo inválido. El tamaño del archivo debe ser menor a 25 MB', 'Notificación');
        } else if (ERROR.fileTypes !== undefined) {
          this.toastr.warning('Archivo inválido. Formato no válido, solo PDF, JPEG, JPG y PNG', 'Notificación');
        }
      });
    } else {
      this.deleteFileIfExist();

      const documents = new Documents();

      this.getBase64(this.fileUploadControl3.value[0]).then(
        res => {
          documents.File = this.fileUploadControl3.value[0];
          documents.number = this.document.catTypeDocumentId;
          documents.base64 = res.split(',')[1];
          documents.fechaComprobanteDomicilio = this.date;
          documents.name = this.fileUploadControl3.value[0].name;
          documents.idDocument = this.document.incidentDocumentId;
          this.base64File =  documents.base64;
          this._uploadedFiles.push(documents);
          this.filesUpoladedEvent.emit(this._uploadedFiles);
          // console.log(documents);
          // mandar a guardar documento
          if (this.document.typeDocument == 1) {
            this.invokeServiceUpdateDocumentIncident(documents, 1);
          } else {
            this.invokeServiceUpgradeDocumentAdditionalIncident(documents, 1);
          }
          this.modalRef.hide();
        }
      );
      this.alreadyUpload = true;
    }
  }

  uploadedFilesMdl() {
    // console.log('entra : ');
    // console.log( this.fileUploadControlMdl);
    if (this.fileUploadControlMdl.invalid) {
      this.fileUploadControlMdl.getError().map(ERROR => {
        if (ERROR.fileSize !== undefined) {
          ERROR.fileSize.map(FILE => {
            this.toastr.warning( 'Se quita ' + FILE.file.name + '. El tamaño del archivo debe ser menor a 25 MB', 'Notificación');
            this.fileUploadControlMdl.removeFile(FILE.file);
          });
        } else if (ERROR.fileTypes !== undefined) {
          ERROR.fileTypes.map(FILE => {
            this.toastr.warning( 'Se quita ' + FILE.file.name + '.  Formato no válido, solo PDF, JPEG, JPG y PNG', 'Notificación');
            this.fileUploadControlMdl.removeFile(FILE.file);
          });
        }
      });
    }
  }
  invokeServiceUploadFilesMultiples() {
    // console.log('total de archivos');
    this.deleteFileIfExist();
    this.fileUploadControlMdl.value.forEach(FILE => {
      // console.log(FILE.name);
      const documents = new Documents();
      this.getBase64(FILE).then(
        res => {
          documents.File = FILE;
          documents.number = this.order;
          documents.base64 = res.split(',')[1];
          documents.fechaComprobanteDomicilio = this.date;
          documents.name = FILE.name;
          documents.idDocument = this.order2;
          this.base64File =  documents.base64;
          this._uploadedFiles.push(documents);
          this.filesUpoladedEvent.emit(this._uploadedFiles);
          // mandar a guardar documento
          this.invokeServiceSaveDocumentIncident(documents);
        }
      );
    });
    this.alreadyUpload = true;
    this.modalRef.hide();
  }

  invokeServiceUpdateDocumentIncident(doc, validate) {
    this.spinner.show('sp');
    const documentIncident = {
      incidentDocumentId: doc.idDocument,
      name: doc.name,
      path: doc.base64,
      createdDate: doc.fechaComprobanteDomicilio,
      updateDate: '',
      incidentId: this._incidentId,
      valid: validate,
      reasonRefusal: '',
      catTypeDocumentId: Number(doc.number),
      base: '',
      typeDocument: '',
      documentName: ''
    };
    this.api.updateDocumentIncident(documentIncident)
      .then(
        (response: any) => {
          this.invokeServiceGetDocumentsLoad();
          this.toastr.success('EL DOCUMENTO SE AGREGO CORRECTAMENTE', 'Notificación');
          this.spinner.hide('sp');
        }, error => {
          this.toastr.error('Ocurrió un problema al procesar su petición.', 'Notificación');
          this.spinner.hide('sp');
        }
      );
  }

  invokeServiceGetIncidentDetail(incidentId) {
    this.api.getIncidentDetail(incidentId).then((data: any) => {
      this.dataIncident = data;
      // console.log(this.dataIncident);
    }, error => {
      this.dataIncident = {};
    });
  }

  invokeServiceDownloadFile(doc) {
    // console.log(doc);
    this.spinner.show('sp');
    this.api.getDocumentIncidentById(doc.incidentDocumentId)
      .subscribe(
        (response: any) => {
          // console.log(response);
          if (response == null) {
            this.toastr.info('No existen archivos para descargar');
            this.spinner.hide('sp');
            return;
          } else {
            const dataType = response.type;
            const binaryData = [];
            binaryData.push(response);
            const downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
            downloadLink.setAttribute('download', doc.name);
            document.body.appendChild(downloadLink);
            downloadLink.click();
            downloadLink.remove();
            this.spinner.hide('sp');
          }
        }, error => {
          // console.error(error);
          this.spinner.hide('sp');
        }
      );
  }

  invokeServiceChangePhaseIncident() {
    this.spinner.show('sp');
    if (this.folioInsurance === undefined) {
      this.toastr.info('POR FAVOR INGRESE EL NUMERO DE FOLIO.', 'NOTIFICACIÓN');
      this.spinner.hide('sp');
      return;
    }
    const obj = {
      incidentId: this._incidentId,
      folio: this.folioInsurance
    };
    this.api.changePhaseByIncident(obj)
      .then(
        (response: any) => {
          this.invokeServiceGetIncidentDetail(this._incidentId);
          this.toastr.success('EL SINETRO CAMBIO A DICATMEN', 'NOTIFICACIÓN');
          this.spinner.hide('sp');
          this.folioInsurance = undefined;
        }, error => {
          this.toastr.error('Ocurrió un problema al procesar su petición.', 'Notificación');
          this.spinner.hide('sp');
        }
      );
  }

  reLoadDocuments() {
    // this.addCheckboxes();
    this.invokeServiceGetDocumentsLoad();
    this.invokeServiceGetDocumentsAdditional();
  }
  invokeFunctionConfirmDocumentAdditional(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-lg', keyboard: false});
  }
  invokeServicePostPendingOpinion() {
    this.spinner.show('sp');
    const objectData = {
      incidentId: this._incidentId
    };
    this.api.changePhaseByIncidentOpinion(objectData)
      .then(
        (response: any) => {
          this.invokeServiceGetIncidentDetail(this._incidentId);
          this.toastr.success('EL SINETRO CAMBIO A DICATMEN', 'NOTIFICACIÓN');
          this.spinner.hide('sp');
          this.folioInsurance = undefined;
          if (response.status === 2) {
            const ammia = {
              incidentId: response.incidentId,
              message: response.message,
              base64: '',
              extencion: ''
            };
            this.invokeServiceSendMessageCore(ammia);
          }
        }, error => {
          this.toastr.error('Ocurrió un problema al procesar su petición.', 'Notificación');
          this.spinner.hide('sp');
        }
      );
  }
}
